import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { RemoteConfigStore, SOFTLINE_FEATURE_REMOTE_CONFIG } from '@softline/application';
import { Store } from '@softline/core';
import { defer, filter, from, map, Observable, switchMap } from 'rxjs';
import { SOFTLINE_FEATURE_MDE_BESTELLERFASSUNG } from '../bestellerfassung.shared';
import { BestellerfassungKopf } from '../data/bestellerfassung-kopf';
import { BestellerfassungStore } from '../store/bestellerfassung.store';

const MODULE_NAME = 'mde-bestellung';

const KEY_MAP = {
  lagerortEingeben: 'FELD_LAGERORT',
  bestellungEdiFrage: 'BESTELLUNGEN_EDI',
};

type BestellerfassungRouteData = {
  lagerortEingeben: boolean;
  bestellungEdiFrage: boolean;
  kopf?: BestellerfassungKopf;
};

@Injectable()
export class BestellerfassungResolver {
  constructor(private store: Store) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<BestellerfassungRouteData> {
    return this.store
      .observe(SOFTLINE_FEATURE_REMOTE_CONFIG, RemoteConfigStore.getters.data)
      .pipe(
        filter((data) => !!data?.modules),
        map((data) => {
          const module = data.modules.find((m) => m.module === MODULE_NAME);
          return module;
        }),
        switchMap((module) =>
          defer(() =>
            from(
              this.store.dispatch(
                SOFTLINE_FEATURE_MDE_BESTELLERFASSUNG,
                BestellerfassungStore.actions.loadKopf
              )
            )
          ).pipe(
            switchMap(() =>
              this.store
                .observe(
                  SOFTLINE_FEATURE_MDE_BESTELLERFASSUNG,
                  BestellerfassungStore.getters.kopf // is this the correct getter?
                )
                .pipe(map((kopf) => ({ module, kopf })))
            )
          )
        ),
        map(({ module, kopf }) => {
          const ediValue = module?.properties.find(
            (p) => p.key === KEY_MAP.bestellungEdiFrage
          )?.value;
          const lagerortValue = module?.properties.find(
            (p) => p.key === KEY_MAP.lagerortEingeben
          )?.value;

          const result: BestellerfassungRouteData = {
            kopf,
            bestellungEdiFrage: ediValue === 'frage',
            lagerortEingeben: lagerortValue === 'eingeblendet',
          };
          return result;
        })
      );
  }
}
